module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "miq-for-teams-city.3c5921c7.png" + "?" + Date.now();